<template>
    <v-skeleton-loader
        loading
        type="table"
        :types="{ 'table-tbody': 'table-row-divider@3', 'table-row': `table-cell@8`, 'table-thead': ``, 'table-heading': '', 'table-tfoot': ''}"
    />
</template>

<script>

export default {
    name: "EndpointsLoading",
    props: [],
    data: () => ({

    }),
    created() {
        //
    },
    methods: {
        //
    },
    computed: {
        //
    },
    mounted() {
        //
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>